module.exports = __webpack_public_path__ + "static/media/0 Servatius Vitrine Halterung klein.62550713.jpg";